import React from "react";
import { FormControl, FormControlLabel, Checkbox } from "@mui/material";

interface CheckBoxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const CheckBox: React.FC<CheckBoxProps> = ({ label, checked, onChange }) => {
  return (
    <FormControl>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            color="secondary"
          />
        }
        label={label}
      />
    </FormControl>
  );
};

export default CheckBox;
